interface Props {
  character: {
    attr_str: number; attr_sta: number; attr_dex: number; attr_agl: number
    attr_eye: number; attr_hrg: number; attr_sml: number; attr_voi: number
    attr_int: number; attr_aur: number; attr_wil: number
    morality: number
  }
}

const PHYSICAL_ATTRS = [
  ['STR', 'attr_str'], ['STA', 'attr_sta'], ['DEX', 'attr_dex'], ['AGL', 'attr_agl'],
  ['EYE', 'attr_eye'], ['HRG', 'attr_hrg'], ['SML', 'attr_sml'], ['VOI', 'attr_voi'],
] as const

const MENTAL_ATTRS = [
  ['INT', 'attr_int'], ['AUR', 'attr_aur'], ['WIL', 'attr_wil'],
] as const

export function AttributePanel({ character }: Props) {
  return (
    <div className="border border-parchment-dark rounded p-4 mb-4 bg-white">
      <h3 className="font-cinzel font-semibold text-sm text-accent uppercase tracking-wider mb-3 pb-2 border-b-2 border-accent/20">Attributes</h3>

      <div className="grid grid-cols-2 gap-x-4 text-sm">
        <div>
          {PHYSICAL_ATTRS.map(([label, key]) => (
            <div key={key} className="flex justify-between py-0.5">
              <span className="font-semibold">{label}</span>
              <span>{character[key]}</span>
            </div>
          ))}
        </div>
        <div>
          {MENTAL_ATTRS.map(([label, key]) => (
            <div key={key} className="flex justify-between py-0.5">
              <span className="font-semibold">{label}</span>
              <span>{character[key]}</span>
            </div>
          ))}
          <div className="flex justify-between py-0.5">
            <span className="font-semibold">Morality</span>
            <span>{character.morality}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
